<template>
    <div class="md:flex flex-wrap address-selection">
      <div class="md:w-1/2 lg:w-2/5">
        <h4 class="font-semibold text-lg">Shipping Address</h4>
        <div v-if="!userAddresses.length">No Address found</div>
        <div v-else class="md:pt-10 md:pr-4 lg:pr-20">
          <div
            v-for="(address, index) in userAddresses"
            :key="`address-${index}`"
            @click="selectShippingAddress(index, address.id_token)"
            class="address-box hover:shadow-lg"
            :class="{'selected': index === selectedShippingIndex}"
          >
            <AddressBox :address="address" :allowActions="false" />
          </div>
        </div>
      </div>
      <div class="md:w-1/2 lg:w-2/5 pt-10 md:pt-0 md:pl-4 lg:pl-0">
        <h4 class="font-semibold text-lg">Billing Address</h4>
        <div class="flex items-center h-10" @click="selectedBillingIndex = -1">
          <input type="checkbox" class="w-5 h-5" v-model="sameAsShipping">
          <span
            class="font-bold opacity-75 pl-2 cursor-pointer"
            @click="toggleSameAsShipping"
          >
            Same as shipping address
          </span>
        </div>
        <div v-if="!sameAsShipping">
          <div v-if="!userAddresses.length">No Address found</div>
          <div v-else class="lg:pr-20">
            <div
              v-for="(address, index) in userAddresses"
              :key="`address-${index}`"
              @click="selectBillingAddress(index, address.id_token)"
              class="address-box hover:shadow-lg"
              :class="{'selected': index === selectedBillingIndex}"
            >
              <AddressBox :address="address" :allowActions="false" />
            </div>
          </div>
        </div>
      </div>
      <div class="md:w-full lg:w-1/5 text-right pt-10 lg:pt-0">
        <button
          class="h-12 bg-dark-b px-4 rounded-full w-full lg:w-auto"
          @click="showAddressModal = true"
        >
          Add New Address
        </button>
      </div>
      <AddressFormModal v-if="showAddressModal" @close="closeModal" />
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import AddressBox from '@/shared/components/profile/address/AddressBox'
import AddressFormModal from '@/shared/components/profile/address/AddressFormModal'
import ProductDetails from '@/shared/mixins/ProductDetails'

export default {
  name: 'AddressSeclection',
  mixins: [ ProductDetails ],
  props: {
    billingAddressId: {
      type: Number
    },
    shippingAddressId: {
      type: Number
    },
    sameAddresses: {
      type: Boolean
    },
    cartProducts: {
      required: true
    }
  },
  components: {
    AddressBox,
    AddressFormModal
  },
  data() {
    return {
      showAddressModal: false,
      userAddresses: [],
      selectedShippingIndex: -1,
      selectedBillingIndex: -1,
      sameAsShipping: true
    }
  },
  async created() {
    var products = [];
    this.cartProducts.forEach((product) => {
      /*
      window.ga('ec:addProduct', {
          id: product.productId,                            // Transaction ID. Required.
          name: product.name,                       // Product name. Required. 
          sku: product.sku,                        // SKU/code.
          category: product.categoryName,         // Category or variation.
          quantity: product.quantity,
          price : this.calculateItemPrice(product),
          brand: product.brand
      });
      */
      products.push({
          id: product.productId,                            // Transaction ID. Required.
          name: product.name,                       // Product name. Required. 
          sku: product.sku,                        // SKU/code.
          category: product.categoryName,         // Category or variation.
          quantity: product.quantity,
          price : this.calculateItemPrice(product),
          brand: product.brand
      });
    });
      /*
      window.ga('ec:setAction','checkout', {
          'step': 3,            // A value of 1 indicates this action is first checkout step.
          'option': 'Select Address'      // Used to specify additional info about a checkout stage, e.g. payment method.
      });
      window.ga('send', 'pageview');
      */
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      'event': 'checkout',
      'ecommerce': {
        'checkout': {
          'actionField': {'step': 3, 'option': 'Select Address'},
          'products': products
        }
      }
    });
    this.userAddresses = await this.fetchBuyerAddresses()
    this.sameAsShipping = this.sameAddresses
    if (this.userAddresses.length) {
      this.userAddresses.forEach((add, index) => {
        if (add.id_token === this.shippingAddressId) {
          this.selectedShippingIndex = index
          if (this.sameAddresses) {
            this.selectedBillingIndex = index
          }
        } else if (add.id_token === this.billingAddressId) {
          this.selectedBillingIndex = index
        }
      })
    }
  },
  computed: {
    ...mapGetters ([
      'getUserAuthInfo'
    ])
  },
  methods: {
    ...mapActions ([
      'fetchBuyerAddresses'
    ]),
    async closeModal(data) {
      this.showAddressModal = false
      if (data) this.userAddresses = await this.fetchBuyerAddresses()
    },
    selectShippingAddress(index, id) {
      this.selectedShippingIndex = this.selectedShippingIndex === index ? -1 : index
      const selectedId = this.selectedShippingIndex === -1 ? null : id
      this.$emit('changeShippingAddress', selectedId, this.sameAsShipping)
    },
    selectBillingAddress(index, id) {
      this.selectedBillingIndex = this.selectedBillingIndex === index ? -1 : index
      const selectedId = this.selectedBillingIndex === -1 ? null : id
      this.$emit('changeBillingAddress', selectedId)
    },
    toggleSameAsShipping() {
      this.sameAsShipping = !this.sameAsShipping
      this.$emit('sameBillingAddress', this.sameAsShipping)
    }
  }
}
</script>
<style lang="scss" scoped>
  .address-selection {
    .address-box {
      @apply mt-4 p-6 border-2 rounded-lg cursor-pointer bg-white;
    }
    .selected {
      @apply border-green shadow-lg;
    }
  }
</style>